import React from 'react';

const CheckMark = (): JSX.Element => {
  return <div className="checkmark fs-11 fw-700"></div>;
};

export default CheckMark;
